// Browser-Benachrichtigungen für fällige VGÜ-Termine
// Einmalig pro Tag beim App-Start, wenn Berechtigung erteilt

const LS_LAST_CHECK = 'amed_notif_last_check';

export function isNotificationSupported(): boolean {
  return 'Notification' in window;
}

export function getNotificationPermission(): NotificationPermission {
  if (!isNotificationSupported()) return 'denied';
  return Notification.permission;
}

export async function requestNotificationPermission(): Promise<NotificationPermission> {
  if (!isNotificationSupported()) return 'denied';
  if (Notification.permission !== 'default') return Notification.permission;
  return Notification.requestPermission();
}

export async function checkAndNotifyFaelligkeiten(): Promise<void> {
  if (!isNotificationSupported() || Notification.permission !== 'granted') return;

  const today = new Date().toISOString().slice(0, 10);
  if (localStorage.getItem(LS_LAST_CHECK) === today) return;
  localStorage.setItem(LS_LAST_CHECK, today);

  try {
    const { loadFaelligkeiten } = await import('./vorsorgeService');
    const alle = await loadFaelligkeiten();

    const in7Tagen = new Date();
    in7Tagen.setDate(in7Tagen.getDate() + 7);
    const limit = in7Tagen.toISOString().slice(0, 10);

    const ueberfaellig = alle.filter(f => f.status === 'UEBERFAELLIG').length;
    const demnächst    = alle.filter(f => f.status === 'OFFEN' && f.faelligkeitDatum <= limit).length;

    if (ueberfaellig === 0 && demnächst === 0) return;

    const parts: string[] = [];
    if (ueberfaellig > 0) parts.push(`${ueberfaellig} überfällig`);
    if (demnächst    > 0) parts.push(`${demnächst} in den nächsten 7 Tagen`);

    new Notification('AMed — VGÜ-Erinnerung', {
      body: `Vorsorgeuntersuchungen: ${parts.join(', ')}`,
      icon: '/icons/pwa-192x192.png',
      tag:  'amed-vgu-reminder',
    });
  } catch {
    // Benachrichtigungsfehler nie den normalen Flow unterbrechen
  }
}
